

import { Injectable } from '@angular/core';

// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';
// import 'rxjs/add/observable/throw';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BadInput } from '../common/bad-input';
import { UnAuthorizeError } from '../common/unauthorize-error';
import { NotFoundError } from '../common/not-found-error';
import { AppError } from '../common/app-error';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CommonFunctionService } from './Common/common-function.service';
import { catchError, map } from 'rxjs/operators';
import { throwError,Observable } from 'rxjs';

@Injectable()
export class DataService {
 

  token;
  headers: any;
  constructor(private http: HttpClient) {
    const helper = new JwtHelperService();

    if (localStorage.getItem('VirtualPOSToken') != null) {
    this.token=helper.decodeToken(localStorage.getItem('VirtualPOSToken'));
    this.headers = new HttpHeaders(). 
    set('Authorization', 'Bearer '+this.token);
    }
  }


 //token;

  // pos
  posauthenticate(url,credentials)
  {   
    // let encodedcredentials=btoa(credentials.username +':'+ credentials.password + ':Reseller' );
    let encodedcredentials=btoa(credentials.employeeid +':'+ credentials.passcode + ':Employee' +':'+ credentials.possubscriptionId );
    const headers = new HttpHeaders().
    // set('Content-Type', 'application/json');
    set('Authorization', 'basic '+encodedcredentials);
    
    return this.http.post(url, '',{headers})
    .pipe(map(response => response)) ;
     // .catch(this.handleError);
  }












  authenticate(url,credentials)
  {   
    let form = { ipaddress: "",ResellerUrl:"",DeviceType:"",GeoLocation:"",AppVersion:""};

    form.ipaddress=credentials.IpAddress;
    form.ResellerUrl=credentials.ResellerUrl;
    form.DeviceType=credentials.DeviceType;
    form.GeoLocation=credentials.GeoLocation;
    form.AppVersion=credentials.AppVersion;
    // let encodedcredentials=btoa(credentials.username +':'+ credentials.password + ':Reseller' );
    let encodedcredentials=btoa(credentials.username +':'+ credentials.password + ':Merchant' );
    const headers = new HttpHeaders().
    // set('Content-Type', 'application/json');
    set('Authorization', 'basic '+encodedcredentials);
    
    return this.http.post(url, form,{headers})
    .pipe(map(response => response)) ;
     // .catch(this.handleError);
  }

  authenticateSupportUser(url,credentials)
  {   
    let form = { ipaddress: "",DeviceType:"",GeoLocation:"",AppVersion:""};

    form.ipaddress=credentials.IpAddress;
    form.DeviceType=credentials.DeviceType;
    form.GeoLocation=credentials.GeoLocation;
    form.AppVersion=credentials.AppVersion;
    const headers = new HttpHeaders().
    set('Authorization', 'basic '+credentials.keyVal);
    return this.http.post(url, form,{headers})
    .pipe(map(response => response)) ;
  }

  getAll(url) {
    return this.http.get(url)  
    .pipe(map(response => response))    
      .pipe(catchError(this.handleError));
  }

  create(url,resource) {
    let encodedcredentials=btoa(resource.email +':'+ this.token + ':InternalApp' );
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'basic '+encodedcredentials);
 
    


    return this.http.post(url, resource)
    .pipe(map(response => response))    
    .pipe(catchError(this.handleError));
  }

  update(url,resource) {
    let encodedcredentials=btoa(resource.email +':'+ this.token + ':InternalApp' );
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'basic '+encodedcredentials);
    // const options = new RequestOptions({headers: headers});
    
    return this.http.patch(url + '/' + resource.id, JSON.stringify({ isRead: true }))
    .pipe(map(response => response))    
    .pipe(catchError(this.handleError));
  }

  put(url, resource) {
    let encodedcredentials = btoa(resource.email + ':' + this.token + ':InternalApp');
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'basic ' + encodedcredentials);
    // const options = new RequestOptions({headers: headers});

    return this.http.put(url, resource)
    .pipe(map(response => response))    
    .pipe(catchError(this.handleError));
  }


  delete(url,email,id) {
    let encodedcredentials=btoa(email +':'+ this.token + ':InternalApp' );
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'basic '+encodedcredentials);
    // const options = new RequestOptions({headers: headers});

    return this.http.delete(url + '/' + id)
    .pipe(map(response => response))    
    .pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    // console.log(error);
    if (error.status === 400 || error.status === 412)
      return throwError(new BadInput(error.json()));
      else if (error.status === 401)
      return throwError(new UnAuthorizeError());
    else if (error.status === 404)
      return throwError(new NotFoundError());
          
    return throwError(new AppError(error));
  }

}
